'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DELETE_PRODUCER_SCREEN = exports.DELETE_PRODUCER_SCREEN = 'deleteProducerScreen';
var EDIT_PRODUCER_SCREEN = exports.EDIT_PRODUCER_SCREEN = 'editProducerScreen';
var UPDATE_ACTIVE_AUDIENCE_SCREEN = exports.UPDATE_ACTIVE_AUDIENCE_SCREEN = 'updateActiveAudienceScreen';
var DELETE_AUDIENCE_SCREEN = exports.DELETE_AUDIENCE_SCREEN = 'deleteAudienceScreen';
var EDIT_AUDIENCE_SCREEN = exports.EDIT_AUDIENCE_SCREEN = 'editAudienceScreen';
var CREATE_PRODUCER_COMPONENT = exports.CREATE_PRODUCER_COMPONENT = 'createProducerComponent';
var VIDEO_SENTIMENT_TRACKING = exports.VIDEO_SENTIMENT_TRACKING = 'videoSentimentTracking';
var EDIT_VIDEO_TYPE = exports.EDIT_VIDEO_TYPE = 'editVideoType';
var EDIT_PRODUCER_COMPONENT = exports.EDIT_PRODUCER_COMPONENT = 'editProducerComponent';
var DELETE_PRODUCER_COMPONENT = exports.DELETE_PRODUCER_COMPONENT = 'deleteProducerComponent';
var CREATE_AUDIENCE_COMPONENT = exports.CREATE_AUDIENCE_COMPONENT = 'createAudienceComponent';
var EDIT_AUDIENCE_COMPONENT = exports.EDIT_AUDIENCE_COMPONENT = 'editAudienceComponent';
var DELETE_AUDIENCE_COMPONENT = exports.DELETE_AUDIENCE_COMPONENT = 'deleteAudienceComponent';
var CREATE_POLL = exports.CREATE_POLL = 'createPoll';
var EDIT_POLL = exports.EDIT_POLL = 'editPoll';
var EDIT_POLL_NAME = exports.EDIT_POLL_NAME = 'editPollName';
var ACTIVE_POLL = exports.ACTIVE_POLL = 'activePoll';
var REVEAL_POLL = exports.REVEAL_POLL = 'revealPoll';
var DELETE_POLL = exports.DELETE_POLL = 'deletePoll';
var SUBMIT_POLL = exports.SUBMIT_POLL = 'submitPoll';
var CREATE_SURVEY = exports.CREATE_SURVEY = 'createSurvey';
var EDIT_SURVEY = exports.EDIT_SURVEY = 'editSurvey';
var EDIT_SURVEY_NAME = exports.EDIT_SURVEY_NAME = 'editSurveyName';
var ACTIVE_SURVEY = exports.ACTIVE_SURVEY = 'activeSurvey';
var REVEAL_SURVEY = exports.REVEAL_SURVEY = 'revealSurvey';
var CREATE_SURVEY_PAGE = exports.CREATE_SURVEY_PAGE = 'createSurveyPage';
var DELETE_SURVEY = exports.DELETE_SURVEY = 'deleteSurvey';
var SUBMIT_SURVEY = exports.SUBMIT_SURVEY = 'submitSurvey';
var CREATE_QUESTION = exports.CREATE_QUESTION = 'createQuestion';
var EDIT_QUESTION = exports.EDIT_QUESTION = 'editQuestion';
var DELETE_QUESTION = exports.DELETE_QUESTION = 'deleteQuestion';
var CREATE_FOLDER = exports.CREATE_FOLDER = 'createFolder';
var EDIT_FOLDER = exports.EDIT_FOLDER = 'editFolder';
var DELETE_FOLDER = exports.DELETE_FOLDER = 'deleteFolder';
var ADD_SLIDESHOW_PDF_URL = exports.ADD_SLIDESHOW_PDF_URL = 'addSlideshowPdfUrl';
var ADD_SLIDESHOW_PDF_FILE_NAME = exports.ADD_SLIDESHOW_PDF_FILE_NAME = 'addSlideshowPdfFileName';
var ADD_SLIDESHOW_PDF = exports.ADD_SLIDESHOW_PDF = 'addSlideshowPdf';
var SLIDESHOW_PDF_UPLOADING = exports.SLIDESHOW_PDF_UPLOADING = 'slideshowPdfUploading';
var UPDATE_SLIDESHOW_INDEX = exports.UPDATE_SLIDESHOW_INDEX = 'updateSlideshowIndex';
var RESET_SLIDESHOW_TO_DEFAULT = exports.RESET_SLIDESHOW_TO_DEFAULT = 'resetSlideshowToDefault';
var SLIDESHOW_RATIO_COMPUTED = exports.SLIDESHOW_RATIO_COMPUTED = 'slideshowRatioComputed';
var CHANGE_EVENT_STATUS = exports.CHANGE_EVENT_STATUS = 'changeEventStatus';
var CHANGE_IFRAME_URL_PRODUCER = exports.CHANGE_IFRAME_URL_PRODUCER = 'changeIframeUrlProducer';
var CHANGE_IFRAME_URL_AUDIENCE = exports.CHANGE_IFRAME_URL_AUDIENCE = 'changeIframeUrlAudience';
var CHANGE_IFRAME_PARAMS_PRODUCER = exports.CHANGE_IFRAME_PARAMS_PRODUCER = 'changeIframeParamsProducer';
var CHANGE_IFRAME_PARAMS_AUDIENCE = exports.CHANGE_IFRAME_PARAMS_AUDIENCE = 'changeIframeParamsAudience';
var UPDATE_MEETING_PULSE_PRODUCER = exports.UPDATE_MEETING_PULSE_PRODUCER = 'updateMeetingPulseProducer';
var UPDATE_MEETING_PULSE_AUDIENCE = exports.UPDATE_MEETING_PULSE_AUDIENCE = 'updateMeetingPulseAudience';
var ADD_IMAGE_URL_PRODUCER = exports.ADD_IMAGE_URL_PRODUCER = 'addImageUrlProducer';
var ADD_IMAGE_URL_AUDIENCE = exports.ADD_IMAGE_URL_AUDIENCE = 'addImageUrlAudience';
var CHANGE_IMAGE_LINK_PRODUCER = exports.CHANGE_IMAGE_LINK_PRODUCER = 'changeImageLinkProducer';
var CHANGE_IMAGE_LINK_AUDIENCE = exports.CHANGE_IMAGE_LINK_AUDIENCE = 'changeImageLinkAudience';
var TOGGLE_DROP_SHADOW_PRODUCER = exports.TOGGLE_DROP_SHADOW_PRODUCER = 'toggleDropShadowProducer';
var TOGGLE_DROP_SHADOW_AUDIENCE = exports.TOGGLE_DROP_SHADOW_AUDIENCE = 'toggleDropShadowAudience';
var TOGGLE_ROUNDED_CORNERS_PRODUCER = exports.TOGGLE_ROUNDED_CORNERS_PRODUCER = 'toggleRoundedCornersProducer';
var TOGGLE_ROUNDED_CORNERS_AUDIENCE = exports.TOGGLE_ROUNDED_CORNERS_AUDIENCE = 'toggleRoundedCornersAudience';
var CUSTOMIZE_QA_FIELDS_AUDIENCE = exports.CUSTOMIZE_QA_FIELDS_AUDIENCE = 'customizeQaComponentAudience';
var CUSTOMIZE_QA_FIELDS_PRODUCER = exports.CUSTOMIZE_QA_FIELDS_PRODUCER = 'customizeQaComponentProducer';
var CUSTOMIZE_TIMER_COMPONENT = exports.CUSTOMIZE_TIMER_COMPONENT = 'customizeTimerComponent';
var UPDATE_PRODUCER_TEXTBOX = exports.UPDATE_PRODUCER_TEXTBOX = 'updateProducerTextBox';
var UPDATE_AUDIENCE_TEXTBOX = exports.UPDATE_AUDIENCE_TEXTBOX = 'updateAudienceTextBox';
var UPDATE_PRODUCER_STICKY_ASPECT_STATUS = exports.UPDATE_PRODUCER_STICKY_ASPECT_STATUS = 'updateProducerStickyAspectStatus';
var UPDATE_AUDIENCE_STICKY_ASPECT_STATUS = exports.UPDATE_AUDIENCE_STICKY_ASPECT_STATUS = 'updateAudienceStickyAspectStatus';
var UPDATE_PRODUCER_STICKY_SIZE = exports.UPDATE_PRODUCER_STICKY_SIZE = 'updateProducerStickySize';
var UPDATE_AUDIENCE_STICKY_SIZE = exports.UPDATE_AUDIENCE_STICKY_SIZE = 'updateAudienceStickySize';
var CREATE_SCREEN = exports.CREATE_SCREEN = 'createScreen';
var CREATE_PRODUCER_SCREEN = exports.CREATE_PRODUCER_SCREEN = 'createProducerScreen';
var CREATE_AUDIENCE_SCREEN = exports.CREATE_AUDIENCE_SCREEN = 'createAudienceScreen';
var EDIT_SCREEN_ORDER = exports.EDIT_SCREEN_ORDER = 'editScreenOrder';
var EDIT_COMPONENT_ORDER = exports.EDIT_COMPONENT_ORDER = 'editComponentOrder';
var UPDATE_SCREEN_LOCK = exports.UPDATE_SCREEN_LOCK = 'updateScreenLock';
var TOGGLE_TRANSPARENT_BACKGROUND_PRODUCER = exports.TOGGLE_TRANSPARENT_BACKGROUND_PRODUCER = 'toggleTransparentBackgroundProducer';
var TOGGLE_TRANSPARENT_BACKGROUND_AUDIENCE = exports.TOGGLE_TRANSPARENT_BACKGROUND_AUDIENCE = 'toggleTransparentBackgroundAudience';

//Pre-recorded Video
var PRERECORDED_SET_VOD_DATA = exports.PRERECORDED_SET_VOD_DATA = 'prerecordedSetVodData';
var PRERECORDED_FILE_STATUS_CHANGE_PRODUCER = exports.PRERECORDED_FILE_STATUS_CHANGE_PRODUCER = 'prerecordedFileStatusChangeProducer';
var PRERECORDED_RESET_VIDEO_PRODUCER = exports.PRERECORDED_RESET_VIDEO_PRODUCER = 'prerecordedResetVideoProducer';

var SET_NAME_VISIBILITY_PRODUCER = exports.SET_NAME_VISIBILITY_PRODUCER = 'setNameVisibilityProducer';
var SET_TIMESTAMP_VISIBILITY_PRODUCER = exports.SET_TIMESTAMP_VISIBILITY_PRODUCER = 'setTimestampVisibilityProducer';
var SET_PRIMARY_BACKGROUND_COLOR_PRODUCER = exports.SET_PRIMARY_BACKGROUND_COLOR_PRODUCER = 'setPrimaryBackgroundColorProducer';
var SET_SECONDARY_BACKGROUND_COLOR_PRODUCER = exports.SET_SECONDARY_BACKGROUND_COLOR_PRODUCER = 'setSecondaryBackgroundColorProducer';
var SET_PRIMARY_TEXT_COLOR_PRODUCER = exports.SET_PRIMARY_TEXT_COLOR_PRODUCER = 'setPrimaryTextColorProducer';
var SET_PRIMARY_TEXT_COLOR_AUDIENCE = exports.SET_PRIMARY_TEXT_COLOR_AUDIENCE = 'setPrimaryTextColorAudience';
var SET_FONT_SIZE_PRODUCER = exports.SET_FONT_SIZE_PRODUCER = 'setFontSizeProducer';
var SET_SELECTED_FOLDER_PRODUCER = exports.SET_SELECTED_FOLDER_PRODUCER = 'setSelectedFolderProducer';
var SET_START_DATE_VISIBILITY = exports.SET_START_DATE_VISIBILITY = 'setStartDateVisibility';
var TOGGLE_EMAIL_FORWARDING = exports.TOGGLE_EMAIL_FORWARDING = 'toggleEmailForwarding';
var TOGGLE_INCLUDE_USER_INFO = exports.TOGGLE_INCLUDE_USER_INFO = 'toggleIncludeUserInfo';

var SET_COUNTDOWN_DATA = exports.SET_COUNTDOWN_DATA = 'setCountdownData';

var EventStatusEnum = exports.EventStatusEnum = Object.freeze({
  RUNNING: 'RUNNING',
  SCHEDULED: 'SCHEDULED',
  COMPLETED: 'COMPLETED',
  STAGED: 'STAGED',
  ARCHIVED: 'ARCHIVED'
});
var DestinationTypeEnum = exports.DestinationTypeEnum = Object.freeze({
  PRODUCER: 'producer',
  ARCHIVED: 'archived',
  VIEWER: 'viewer'
});
var ScreenTypesEnum = exports.ScreenTypesEnum = Object.freeze({
  LOBBY: 'lobby',
  EXIT: 'exit',
  EVENT: 'event',
  TEAM_VIEW: 'teamView'
});
var ComponentTypes = exports.ComponentTypes = Object.freeze({
  AV: 'av',
  QA: 'qa',
  TEXT: 'text',
  IMAGE: 'image',
  SLIDESHOW: 'slideshow',
  POLLS: 'polls',
  SURVEYS: 'surveys'
});

var VIDEO_DELIVERY_OPTION = exports.VIDEO_DELIVERY_OPTION = 'videoDeliveryOption';
var CREATE_SMARTBRIDGE_SESSION = exports.CREATE_SMARTBRIDGE_SESSION = 'createSmartbridgeSession';